import React, { useState, useEffect } from 'react';

const LegalDoc = ( { fileName, documentType } ) => {
    const [document, setDocument] = useState("");

    useEffect(() => {
        const loadFile = async () => {
            try {
                const response = await fetch(process.env.PUBLIC_URL + "/" + fileName);
                setDocument(await response.text());
            }
            catch (error)
            {
                console.error("Error reading text file:", error);
            }
        }

        loadFile();
    })

    return (
        <main className="flex-grow flex flex-col justify-center items-center">
            <h1 className="text-3xl font-semibold text-center mt-5">Data Revival {documentType}</h1>
            <div className="flex-grow max-w-200 my-5 p-4 shadow-lg flex flex-col rounded-2xl">
                <pre className="h-0 flex-grow overflow-y-auto no-scrollbar font-mono text-sm">
                    {document}
                </pre>
            </div>
        </main>
    );
};

export default LegalDoc;